module.exports = new __parcel__URL__("Warning.e56d4e3e.svg").toString();